import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { fetchWallet } from '../../store/slices/walletSlice';
import { ROUTES } from '../../config/appConfig';
import {formatDriverCurrency} from '../../utils/driverMoney';
import { WALLET_REQUIRED_MESSAGE } from '../../utils/wallet';
export default function WalletGate() {
  const { data, loading, error } = useSelector(state => state.wallet);
  const dispatch = useDispatch();
  if (data?.canAcceptOrders === true && !error) return null;
  return <Alert variant="warning"><p>{loading ? 'Checking wallet before accepting orders...' : error || (data?.canAcceptOrders === false && data.balance < data.minimumRequiredBalance ? WALLET_REQUIRED_MESSAGE : 'Complete driver verification and approval before accepting orders.')}</p>
    {data && <p>Current balance: {formatDriverCurrency(data.balance,'rupees')}. Required balance: {formatDriverCurrency(data.minimumRequiredBalance,'rupees')}.</p>}
    <Button as={Link} to={ROUTES.driverWallet}>Add Money</Button>{' '}<Button variant="outline-secondary" disabled={loading} onClick={() => dispatch(fetchWallet())}>Refresh wallet</Button>
  </Alert>;
}
